module.exports = {
  context: {
    icon: {
      svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    },
    heading: {
      text: 'Challenge',
      tag: 'h3',
      class: 'heading-3'
    },
    shortDescription: {
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    }
  }
}
